import * as cp from './cp';
import * as cpTypes from './types';

const {
        KAKAOTV_NO_LIVE,
        KAKAOTV_OPEN,
        DAUM_BLOG,
        DAUM_CAFE,
        TISTORY,
        NAVER_BLOG,
        YOUTUBE,
        ETC
      } = cp;

const { CP_TYPE_KAKAOTV, CP_TYPE_YOUTUBE, CP_TYPE_ETC } = cpTypes;

export default {
  codes :  cp,
  CPTypes : cpTypes,
  docTypes: {
    KAKAO_POPULAR: 'tvpotPopular',
    KAKAO_PLAYLIST: 'tvpotPlaylist'
  },
  define  : {
    [KAKAOTV_NO_LIVE]: {
      type    : CP_TYPE_KAKAOTV,
      isFamily: true
    },
    [KAKAOTV_OPEN]   : {
      type    : CP_TYPE_KAKAOTV,
      isFamily: true
    },
    [DAUM_BLOG]      : {
      type    : CP_TYPE_KAKAOTV,
      isFamily: true
    },
    [DAUM_CAFE]      : {
      type    : CP_TYPE_KAKAOTV,
      isFamily: true
    },
    [TISTORY]        : {
      type    : CP_TYPE_KAKAOTV,
      isFamily: true
    },
    [NAVER_BLOG]     : {
      type    : CP_TYPE_ETC,
      isFamily: false
    },
    [YOUTUBE]        : {
      type    : CP_TYPE_YOUTUBE,
      isFamily: false
    },
    [ETC]            : {
      type    : CP_TYPE_ETC,
      isFamily: false
    }
  },
  PDGrades: {
    S: 'star',
    A: 'pro',
    B: 'rookie'
  },
  of(cp) {
    return this.define[cp] || this.define[ETC];
  },
  cpToType(cp) {
    return this.of(cp).type;
  },
  PDGradeToClassName(PDGrade) {
    return this.PDGrades[PDGrade] || '';
  }
};


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/cp-meta/index.js
 **/